import Vue from "vue";
import Vuex from "@store/store";
import { baseUrl, isSignedIn, getHeaders } from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

Vue.use(Vuex);

export async function GenericServicesGetDropdowns() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Generic/dropdowns`;

    const generics = {
        data: Vuex.getters["generics/getStateGenericDropdowns"],
    };

    if (_.isEmpty(generics.data)) {
        const promise = axios.get(urlApi, getHeaders());
        promise.then((result) => {
            Vuex.commit("generics/setStateGenericDropdowns", result.data);
        });
        return promise;
    } else {
        return new Promise((resolve, reject) => {
            resolve(generics);
        });
    }
}

export async function GenericServicesGetCountriesAndDistricts() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Generic/dropdowns/countries-districts`;

    return axios.get(urlApi, getHeaders());
}

export async function GenericServicesEntityType() {
    const urlApi = `${baseUrl}/Generic/dropdowns/entitytype`;

    return axios.get(urlApi);
}

export async function GenericServicesGetCalendarHoursDrop() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Generic/calendar/hours`;

    const calendarHoursDropdown = {
        data: {
            result: Vuex.getters[
                "backofficeCalendarHoursDropdown/getStateCalendarHoursDropdown"
            ],
        },
    };

    if (_.isEmpty(calendarHoursDropdown.data.result)) {
        return axios.get(urlApi, getHeaders());
    } else {
        return new Promise((resolve, reject) => {
            resolve(calendarHoursDropdown);
        });
    }
}

export async function GenericServicesGetDropdownUsersRoles() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Generic/dropdowns/roles`;

    const generics = {
        data: Vuex.getters["generics/getStateGenericRoles"],
    };

    if (_.isEmpty(generics.data)) {
        let promise = axios.get(urlApi, getHeaders());
        promise.then((result) => {
            Vuex.commit("generics/setStateGenericRoles", result.data);
        });
        return promise;
    } else {
        return new Promise((resolve, reject) => {
            resolve(generics);
        });
    }
}

export async function GenericServicesGetVrmAccessTipology() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Generic/dropdowns/vrmaccess-tipology`;

    return axios.get(urlApi, getHeaders());
}

export async function GenericServicesGetDropdownModules() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Generic/dropdowns/modules`;

    return axios.get(urlApi, getHeaders());
}

export async function GenericServicesGetHealthChecks() {
    await isSignedIn();

    const urlApi = `${baseUrl}/endpoint/healthcheck`;

    return axios.get(urlApi, getHeaders());
}

export async function GenericServicesGetVideosFromYoutubePlaylist(
    youtubePlaylist
) {
    await isSignedIn();

    let query = queryFilter({
        playlistId: youtubePlaylist,
    });
    const urlApi = `${baseUrl}/Generic/youtube/playlist-items/${query}`;

    return axios.get(urlApi, getHeaders());
}
